<template>
  <v-dialog
    v-model="dialog"
    scrollable
    width="800"
  >
    <v-card >
      <v-toolbar dense :elevation="0" style="flex-grow: 0;">
        <v-toolbar-title class="text-primary-700">Add Deal - Sale</v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-btn style="width: 35px; height: 35px" icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text class="pa-4">
        <v-stepper v-model="step" vertical :elevation="0" class="rpd-stepper pb-0" style="margin: auto; max-width: 800px;">
          <v-stepper-step editable step="1" class="pb-4 pt-4" :complete="step > 1">
            Select a Property that has been Sold:<br/>
            <!-- small text -->
            <!-- <small v-if="step == 1">Select whether you would like to be added as a Tenant or Tenants Agent</small> -->
          </v-stepper-step>
          <v-stepper-content step="1">
            <v-col cols="4">
              <v-btn-toggle v-model="typeToggle" 
                color="primary"
                mandatory
                small
                style="width:100%"
                variant="default"
                >
                <v-btn small style="width:50%" :value="false">
                  Scheme
                </v-btn>
                <v-btn small style="width:50%" :value="true">
                  Property
                </v-btn>
              </v-btn-toggle>
            </v-col>
            <v-col cols="8" v-if="!typeToggle">
              <v-combobox
                outlined
                dense
                hide-details
                v-model="selectedScheme"
                :items="schemes"
                :item-title="item => item.label"
                :item-value="item => item.value"
                :item-text="'label'"
                placeholder="Begin typing to search for a scheme"
                label="Scheme"
                :loading="schemeLoading"
                :disabled="prefill"
                clearable
                :filter="(item, queryText) => {
                  return item
                }"
                ref="schemeCombobox"
                @update:search-input="searchScheme($event)"
              ></v-combobox>
            </v-col>
            <v-col cols="8" v-else>
              <v-combobox
                outlined
                dense
                hide-details
                v-model="selectedProperties"
                :items="Properties"
                :item-title="item => item.label"
                :item-value="item => item.value"
                :item-text="'label'"
                :return-object="true"
                :disabled="prefill"
                placeholder="Begin typing to search for a property"
                label="Property"
                :loading="propertiesLoading"
                clearable
                :filter="(item, queryText) => {
                  return item
                }"
                ref="propertiesCombobox"
                @update:search-input="searchProperties($event)"
              ></v-combobox>
            </v-col>
            <v-col cols="12">
              <v-btn
                @click="handleSelect"
                color="primary"
                depressed
                :disabled="propertyValidation || schemeValidation">
                <span v-if="typeToggle">Select Property</span>
                <span v-else>Select Scheme</span>
              </v-btn>
            </v-col>
          </v-stepper-content>
          <v-stepper-step :editable="step > 1" step="2" :complete="step > 2" class="pt-4">
            Check Property Information <br/>
            <!-- small text -->
            <!-- <small v-if="step == 2">Add the {{ contactTypeText }} to the deal</small> -->
          </v-stepper-step>
          <v-stepper-content step="2">
                <h5 v-if="typeToggle" class="text-h7 mb-1 pa-0 form-subheading">Property</h5>
                <h5 v-else class="text-h7 mb-1 pa-0 form-subheading">Address</h5>
            <v-row class="">
              <!-- country -->
              <v-col cols="6">
                <v-text-field
                  outlined
                  dense
                  hide-details
                  class="pt-0"
                  v-model="form.country"
                  label="Country"
                  clearable
                ></v-text-field>
              </v-col>
              <!-- unit -->
              <v-col cols="6">
                <v-text-field
                  outlined
                  dense
                  hide-details
                  class="pt-0"
                  v-model="form.unit"
                  label="Unit"
                  clearable
                ></v-text-field>
              </v-col>
              <!-- street 1 -->
              <v-col cols="6">
                <v-text-field
                outlined
                  dense
                  hide-details
                  class="pt-0"
                  v-model="form.street1"
                  label="Street 1"
                  clearable
                ></v-text-field>
              </v-col>
              <!-- street 2 -->
              <v-col cols="6">
                <v-text-field
                outlined
                  dense
                  hide-details
                  class="pt-0"
                  v-model="form.street2"
                  label="Street 2"
                  clearable
                ></v-text-field>
              </v-col>
              <!-- town -->
              <v-col cols="6">
                <v-text-field
                outlined
                  dense
                  hide-details
                  class="pt-0"
                  v-model="form.town"
                  label="Town"
                  clearable
                ></v-text-field>
              </v-col>
              <!-- post code -->
              <v-col cols="6"> 
                <v-text-field
                outlined
                  dense
                  hide-details
                  class="pt-0"
                  v-model="form.postCode"
                  label="Post Code"
                  clearable
                ></v-text-field>
              </v-col>
            </v-row>
            <v-divider class="my-8"></v-divider>
            <template v-if="typeToggle">
              <h5 class="text-h7 mb-1 pa-0 form-subheading">Planning</h5>
              <v-row>
                <v-col cols="6">
                  <!-- planning text field -->
                  <v-text-field
                    outlined
                    dense
                    hide-details
                    v-model="form.planning"
                    label="Planning"
                    clearable
                    class="pt-0"
                  ></v-text-field>
                </v-col>
              </v-row>
            </template>
            <template v-else>
              <h5  class="text-h7 mb-1 pa-0 form-subheading">Scheme</h5>
              <v-row>
                <v-col cols="8">
                  <v-text-field
                    outlined
                    dense
                    hide-details
                    v-model="form.scheme_name"
                    v-validate="'required|min:1'"
                    :error-messages="errors.collect('form.scheme_name')"
                    label="Scheme Name"
                    data-vv-name="form.scheme_name"
                    data-vv-as="scheme_name"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-select
                  outlined
                    dense
                    hide-details
                    v-model="form.scheme_type"
                    :items="['Leisure','Out of town','Shopping centres',]"
                    label="Type"
                    required
                    v-validate="'required'"
                    :error-messages="errors.collect('form.scheme_type')"
                    data-vv-name="form.scheme_type"
                    data-vv-as="scheme_type"
                  ></v-select>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                  outlined
                    dense
                    hide-details
                    v-model="form.opened"
                    v-validate="''"
                    :error-messages="errors.collect('form.opened')"
                    label="Opened (Year)"
                    data-vv-name="form.opened"
                    data-vv-as="Opened"
                    type="text"
                    v-mask="'####'"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                  outlined
                    dense
                    hide-details
                    v-model="form.car_spaces"
                    v-validate="'min_value:0'"
                    :error-messages="errors.collect('form.car_spaces')"
                    label="Car Spaces"
                    data-vv-name="form.car_spaces"
                    data-vv-as="Car Spaces"
                    type="number"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-checkbox
                    v-model="form.under_construction"
                    label="Under Construction?"
                    required
                    hide-details
                    class="mt-1"
                  ></v-checkbox>
                </v-col>
                <!-- true false under construction -->
              </v-row>
            </template>


           
            <template v-if="typeToggle">
              <v-divider class="my-8"></v-divider>
              <h5  class="text-h7 mb-1 pa-0 form-subheading">Areas</h5>
              <!-- <v-alert class="alert-expandable ml-4" dense type="info" color="warning" fade small v-if="!areaChecklist.nia_sqrt && !areaChecklist.mezzanine && !areaChecklist.garden_centre && !areaChecklist.itza_area && !areaChecklist.ground_floor_area && !areaChecklist.first_floor_area && !areaChecklist.second_floor_area && !areaChecklist.third_floor_area && !areaChecklist.basement_area && !areaChecklist.frontage_area">
                This property has no areas set.
              </v-alert> -->
              <v-row >
                <!-- areas subheading -->
                
                <v-col cols="3" v-if="areaChecklist.nia_sqrt || areaChecklist.mezzanine || areaChecklist.garden_centre || areaChecklist.itza_area || areaChecklist.ground_floor_area || areaChecklist.first_floor_area || areaChecklist.second_floor_area || areaChecklist.third_floor_area || areaChecklist.basement_area || areaChecklist.frontage_area">
                  <!-- dont show area type if there arent any fields that use it -->
                  <v-autocomplete
                    outlined
                    dense
                    hide-details
                    v-model="form.area_size_type"
                    :items="[{value:'sqft', name:'sqft'}, {value:'sqm', name:'sqm'}]"
                    cache-items
                    flat
                    hide-no-data
                    clearable
                    item-text="name"
                    item-value="value"
                    label="Area"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="3" v-if="areaChecklist.nia_sqrt">
                  <v-text-field
                  outlined
                    dense
                    hide-details
                    v-model="form.nia_sqrt"
                    v-validate="''"
                    :error-messages="errors.collect('form.nia_sqrt')"
                    label="NIA"
                    data-vv-name="form.nia_sqrt"
                    data-vv-as="NIA"
                    type="number"
                  ></v-text-field>
                </v-col>
                <v-col cols="3" v-if="areaChecklist.mezzanine">
                  <v-text-field
                  outlined
                    dense
                    hide-details
                    v-model="form.mezzanine"
                    v-validate="''"
                    :error-messages="errors.collect('form.mezzanine')"
                    label="Mezz/FF"
                    data-vv-name="form.mezzanine"
                    data-vv-as="Mezz/FF"
                    type="number"
                  ></v-text-field>
                </v-col>
                <v-col cols="3" v-if="areaChecklist.garden_centre">
                  <v-text-field
                  outlined
                    dense
                    hide-details
                    v-model="form.garden_centre"
                    v-validate="''"
                    :error-messages="errors.collect('form.garden_centre')"
                    label="GC"
                    data-vv-name="form.garden_centre"
                    data-vv-as="GC"
                    type="number"
                  ></v-text-field>
                </v-col>
                <v-col cols="3" v-if="areaChecklist.itza_area">
                  <v-text-field
                  outlined
                    dense
                    hide-details
                    v-model="form.itza_area"
                    v-validate="''"
                    :error-messages="errors.collect('form.itza_area')"
                    label="ITZA"
                    data-vv-name="form.itza_area"
                    data-vv-as="ITZA"
                    type="number"
                  ></v-text-field>
                </v-col>
                <v-col cols="3" v-if="areaChecklist.ground_floor_area">
                  <v-text-field
                  outlined
                    dense
                    hide-details
                    v-model="form.ground_floor_area"
                    v-validate="''"
                    :error-messages="errors.collect('form.ground_floor_area')"
                    label="Ground Floor"
                    data-vv-name="form.ground_floor_area"
                    data-vv-as="Ground Floor"
                    type="number"
                  ></v-text-field>
                </v-col>
                <v-col cols="3" v-if="areaChecklist.first_floor_area">
                  <v-text-field
                  outlined
                    dense
                    hide-details
                    v-model="form.first_floor_area"
                    v-validate="''"
                    :error-messages="errors.collect('form.first_floor_area')"
                    label="First Floor"
                    data-vv-name="form.first_floor_area"
                    data-vv-as="First Floor"
                    type="number"
                  ></v-text-field>
                </v-col>
                <v-col cols="3" v-if="areaChecklist.second_floor_area">
                  <v-text-field
                  outlined
                    dense
                    hide-details
                    v-model="form.second_floor_area"
                    v-validate="''"
                    :error-messages="errors.collect('form.second_floor_area')"
                    label="Second Floor"
                    data-vv-name="form.second_floor_area"
                    data-vv-as="Second Floor"
                    type="number"
                  ></v-text-field>
                </v-col>
                <v-col cols="3" v-if="areaChecklist.third_floor_area">
                  <v-text-field
                  outlined
                    dense
                    hide-details
                    v-model="form.third_floor_area"
                    v-validate="''"
                    :error-messages="errors.collect('form.third_floor_area')"
                    label="Third Floor"
                    data-vv-name="form.third_floor_area"
                    data-vv-as="Third Floor"
                    type="number"
                  ></v-text-field>
                </v-col>
                <v-col cols="3" v-if="areaChecklist.basement_area">
                  <v-text-field
                  outlined
                    dense
                    hide-details
                    v-model="form.basement_area"
                    v-validate="''"
                    :error-messages="errors.collect('form.basement_area')"
                    label="Basement"
                    data-vv-name="form.basement_area"
                    data-vv-as="Basement"
                    type="number"
                  ></v-text-field>
                </v-col>
                <v-col cols="3" v-if="areaChecklist.frontage_area">
                  <v-text-field
                  outlined
                    dense
                    hide-details
                    v-model="form.frontage_area"
                    v-validate="''"
                    :error-messages="errors.collect('form.frontage_area')"
                    label="Frontage"
                    data-vv-name="form.frontage_area"
                    data-vv-as="Frontage"
                    type="number"
                  ></v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-menu offset-y :close-on-content-click="false">
                    <template v-slot:activator="{ on: onMenu }">
                      <v-btn @click="" height="40" width="100%" color="primary" outlined v-on="onMenu">
                        <v-icon>mdi-plus</v-icon>
                        Add Areas
                      </v-btn>
                    </template>
                    <!-- checkbox for each area type -->
                    <v-card style="width: 400px;" class="px-4 py-4">
                      <v-row>
                        <v-col cols="6">
                            <v-checkbox class="mt-0" :ripple="false" hide-details v-model="areaChecklist.nia_sqrt" label="NIA"></v-checkbox>
                          </v-col>
                          <v-col cols="6">
                            <v-checkbox class="mt-0" :ripple="false" hide-details v-model="areaChecklist.mezzanine" label="Mezz/FF"></v-checkbox>
                            </v-col>
                          <v-col cols="6">
                            <v-checkbox class="mt-0" :ripple="false" hide-details v-model="areaChecklist.garden_centre" label="GC"></v-checkbox>
                            </v-col>
                          <v-col cols="6">
                            <v-checkbox class="mt-0" :ripple="false" hide-details v-model="areaChecklist.itza_area" label="ITZA"></v-checkbox>
                            </v-col>
                          <v-col cols="6">
                            <v-checkbox class="mt-0" :ripple="false" hide-details v-model="areaChecklist.ground_floor_area" label="Ground Floor"></v-checkbox>
                            </v-col>
                          <v-col cols="6">
                            <v-checkbox class="mt-0" :ripple="false" hide-details v-model="areaChecklist.first_floor_area" label="First Floor"></v-checkbox>
                            </v-col>
                          <v-col cols="6">
                            <v-checkbox class="mt-0" :ripple="false" hide-details v-model="areaChecklist.second_floor_area" label="Second Floor"></v-checkbox>
                            </v-col>
                          <v-col cols="6">
                            <v-checkbox class="mt-0" :ripple="false" hide-details v-model="areaChecklist.third_floor_area" label="Third Floor"></v-checkbox>
                            </v-col>
                          <v-col cols="6">
                            <v-checkbox class="mt-0" :ripple="false" hide-details v-model="areaChecklist.basement_area" label="Basement"></v-checkbox>
                            </v-col>
                          <v-col cols="6">
                            <v-checkbox class="mt-0" :ripple="false" hide-details v-model="areaChecklist.frontage_area" label="Frontage"></v-checkbox>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-menu>
                </v-col>
                
              </v-row>
              
            </template>
            <br/>
            <v-btn
              @click="step = 3"
              color="primary"
              class="mb-4"
              depressed
            >
              Next Step
            </v-btn>
          </v-stepper-content>
          <v-stepper-step step="3" :editable="step > 1" :complete="step > 3" class="pt-4">
            Contact information <br/>
          </v-stepper-step>
          <v-stepper-content step="3">
            <v-row class="">
              <v-col cols="6">
                <!-- vendor subheading -->
                 <h5 class="text-h7 mb-1 pa-0 form-subheading">Vendor</h5>
                <!-- landlord contacts -->
                <v-row>
                  <v-col cols="12">

                
                  <v-autocomplete
                    outlined
                    small-chips
                    hide-details
                    v-model="form.prev_landlords"
                    :loading="prevLandlords.loading"
                    :items="prevLandlords.items"
                    :search-input.sync="prevLandlords.search"
                    cache-items
                    return-object
                    chips
                    multiple
                    flat
                    hide-no-data
                    clearable
                    item-text="name"
                    item-value="id"
                    label="Previous Landlords"
                    v-validate="''"
                    :error-messages="errors.collect('form.prev_landlords')"
                    data-vv-name="form.prev_landlords"
                    data-vv-as="Previous Landlords"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    outlined
                    small-chips
                    hide-details
                    v-model="form.prev_landlord_contacts"
                    :loading="prevLandlordContacts.loading"
                    :items="prevLandlordContacts.items"
                    :search-input.sync="prevLandlordContacts.search"
                    cache-items
                    return-object
                    chips
                    multiple
                    flat
                    hide-no-data
                    clearable
                    item-text="name"
                    item-value="id"
                    label="Previous Landlord Contacts"
                    v-validate="''"
                    :error-messages="errors.collect('form.prev_landlord_contacts')"
                    data-vv-name="form.prev_landlord_contacts"
                    data-vv-as="Previous Landlord Contacts"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    outlined
                    small-chips
                    hide-details
                    v-model="form.prev_landlord_agents"
                    :loading="prevLandlordAgents.loading"
                    :items="prevLandlordAgents.items"
                    :search-input.sync="prevLandlordAgents.search"
                    cache-items
                    return-object
                    chips
                    multiple
                    flat
                    hide-no-data
                    clearable
                    item-text="name"
                    item-value="id"
                    label="Previous Landlord Agents"
                    v-validate="''"
                    :error-messages="errors.collect('form.prev_landlord_agents')"
                    data-vv-name="form.prev_landlord_agents"
                    data-vv-as="Previous Landlord Agents"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    outlined
                    small-chips
                    hide-details
                    v-model="form.prev_landlord_agent_contacts"
                    :loading="prevLandlordAgentContacts.loading"
                    :items="prevLandlordAgentContacts.items"
                    :search-input.sync="prevLandlordAgentContacts.search"
                    cache-items
                    return-object
                    chips
                    multiple
                    flat
                    hide-no-data
                    clearable
                    item-text="name"
                    item-value="id"
                    label="Previous Landlord Agent Contacts"
                    v-validate="''"
                    :error-messages="
                      errors.collect('form.prev_landlord_agent_contacts')
                    "
                    data-vv-name="form.prev_landlord_agent_contacts"
                    data-vv-as="Previous Landlord Agent Contacts"
                  ></v-autocomplete>
                </v-col>
                </v-row>

              </v-col>

              <v-col cols="6">
                <!-- tenant subheading -->
                <!-- <h2 class="text-h6 text-primary-600">Purchasor</h2> -->
                 <h5 class="text-h7 mb-1 pa-0 form-subheading">Purchasor</h5>
                <!-- tenant contacts -->
                <v-row>
                  <v-col cols="12">
                    <v-autocomplete
                    outlined
                    small-chips
                      hide-details
                      v-model="form.landlords"
                      :loading="landlords.loading"
                      :items="landlords.items"
                      :search-input.sync="landlords.search"
                      cache-items
                      return-object
                      chips
                      multiple
                      flat
                      hide-no-data
                      clearable
                      item-text="name"
                      item-value="id"
                      label="Landlords"
                      v-validate="''"
                      :error-messages="errors.collect('form.landlords')"
                      data-vv-name="form.landlords"
                      data-vv-as="Landlords"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete
                    outlined
                    small-chips
                      hide-details
                      v-model="form.landlord_contacts"
                      :loading="landlordContacts.loading"
                      :items="landlordContacts.items"
                      :search-input.sync="landlordContacts.search"
                      cache-items
                      return-object
                      chips
                      multiple
                      flat
                      hide-no-data
                      clearable
                      item-text="name"
                      item-value="id"
                      label="Landlord Contacts"
                      v-validate="''"
                      :error-messages="errors.collect('form.landlord_contacts')"
                      data-vv-name="form.landlord_contacts"
                      data-vv-as="Landlord Contacts"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete
                      outlined
                      small-chips
                      hide-details
                      v-model="form.landlord_agents"
                      :loading="landlordAgents.loading"
                      :items="landlordAgents.items"
                      :search-input.sync="landlordAgents.search"
                      cache-items
                      return-object
                      chips
                      multiple
                      flat
                      hide-no-data
                      clearable
                      item-text="name"
                      item-value="id"
                      label="Landlord Agents"
                      v-validate="''"
                      :error-messages="errors.collect('form.landlord_agents')"
                      data-vv-name="form.landlord_agents"
                      data-vv-as="Landlord Agents"
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete
                      outlined
                      small-chips
                      hide-details
                      v-model="form.landlord_agent_contacts"
                      :loading="landlordAgentContacts.loading"
                      :items="landlordAgentContacts.items"
                      :search-input.sync="landlordAgentContacts.search"
                      cache-items 
                      return-object
                      chips
                      multiple
                      flat
                      hide-no-data
                      clearable
                      item-text="name"
                      item-value="id"
                      label="Landlord Agent Contacts"
                      v-validate="''"
                      :error-messages="
                        errors.collect('form.landlord_agent_contacts')
                      "
                      data-vv-name="form.landlord_agent_contacts"
                      data-vv-as="Landlord Agent Contacts"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-btn
              @click="step = 4"
              color="primary"
              class="mt-4 mb-4"
              depressed
            >
              Next Step
            </v-btn>
          </v-stepper-content>
          <v-stepper-step step="4" :complete="step > 4" :editable="step > 1" class="pt-4">
            Sale Information <br/>
          </v-stepper-step>
          <v-stepper-content step="4">
            <!-- select box for sale type; vacant possesion, investment, sale and lease back, owner occupier -->
            <v-row class="mt-2">
              <v-col cols="6">
                <v-text-field
                  outlined
                  dense
                  hide-details
                  v-model="form.effective_date"
                  label="Effective Date"
                  hint="dd/mm/yyyy format"
                  v-validate="'date_format:dd/MM/yyyy'"
                  :error-messages="errors.collect('form.effective_date')"
                  data-vv-name="form.effective_date"
                  data-vv-as="Effective Date"
                  v-mask="'##/##/####'"
                  append-icon="mdi-calendar"
                  return-masked-value
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-select
                  outlined
                  dense
                  hide-details
                  v-model="form.sale_type"
                  :items="saleTypes"
                  item-text="name"
                  item-value="value"
                  label="Sale Type"
                  clearable
                ></v-select>
              </v-col>
              <v-col>
                <currency-select v-model="form.currency" ref="currencySelectRef" label="Currency"></currency-select>
              </v-col>
              <v-col cols="6">
                <currency-input
                  v-model="form.price_paid"
                  :validation="'decimal:2'"
                  label="Price Paid"
                  :errorMsgs="errors.collect('form.price_paid')"
                  :currency="form.currency ? form.currency.symbol : ''"
                ></currency-input>
              </v-col>
            </v-row>
            <v-btn
              @click="step = 5"
              color="primary"
              class="my-4"
              depressed
            >
              Next Step
            </v-btn>
          </v-stepper-content>
          <v-stepper-step step="5" v-if="(form.sale_type == 'investment' || form.sale_type == 'sale_and_lease_back') && typeToggle" :complete="step > 5" :editable="step > 1" class="pt-4">
            Tenancy Details <br/>
          </v-stepper-step>
          <v-stepper-content step="5" v-if="(form.sale_type == 'investment' || form.sale_type == 'sale_and_lease_back') && typeToggle">
            <!-- <h2 class="text-h6 text-primary-600 mt-4">Tenant</h2> -->
             <h5 class="text-h7 mb-1 pa-0 form-subheading">Tenant</h5>

            <v-row>
              <v-col cols="6">
                <v-autocomplete
                  outlined
                  dense
                  hide-details
                  class="pt-0"
                  v-model="form.tenant_id"
                  :loading="tenants.loading"
                  :items="tenants.items"
                  :search-input.sync="tenants.search"
                  cache-items
                  flat
                  hide-no-data
                  clearable
                  item-text="name"
                  item-value="id"
                  label="Tenant"
                  v-validate="''"
                  :error-messages="errors.collect('form.tenant_id')"
                  data-vv-name="form.tenant_id"
                  data-vv-as="Tenant"
                  hint="The trading name of the tenant. Leave blank if the property is vacant."
                  persistent-hint
                >
                  <template v-slot:item="{ item }">
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ item.name }}
                        <v-tooltip bottom v-if="item.core_id">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                            small
                              :color="item.is_verified ? 'green' : 'orange lighten-1'"
                              v-bind="attrs"
                              v-on="on"
                            >
                              mdi-checkbox-marked-circle-outline
                            </v-icon>
                          </template>
                          <span v-if="item.is_verified">Verified Tracked Retailer</span>
                          <span v-else>This Tracked Retailer has not yet been Verified</span>
                        </v-tooltip>
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="6">
                <v-autocomplete
                outlined
                  dense
                  hide-details
                  class="pt-0"
                  v-model="form.legal_tenant_id"
                  :loading="legalTenants.loading"
                  :items="legalTenants.items"
                  :search-input.sync="legalTenants.search"
                  cache-items
                  flat
                  hide-no-data
                  clearable
                  item-text="name"
                  item-value="id"
                  label="Tenant (Legal)"
                  v-validate="''"
                  :error-messages="errors.collect('form.legal_tenant_id')"
                  data-vv-name="form.legal_tenant_id"
                  data-vv-as="Tenant (Legal)"
                  hint="Optionally set the company which is the legal tenant, if it is different."
                  persistent-hint
                >
                  <template v-slot:item="{ item }">
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ item.name }}
                        <v-tooltip bottom v-if="item.core_id">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                            small
                              :color="item.is_verified ? 'green' : 'orange lighten-1'"
                              v-bind="attrs"
                              v-on="on"
                            >
                              mdi-checkbox-marked-circle-outline
                            </v-icon>
                          </template>
                          <span v-if="item.is_verified">Verified Tracked Retailer</span>
                          <span v-else>This Tracked Retailer has not yet been Verified</span>
                        </v-tooltip>
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="6">
                <v-autocomplete
                outlined
                small-chips
                  hide-details
                  class="pt-0"
                  v-model="form.tenant_contacts"
                  :loading="tenantContacts.loading"
                  :items="tenantContacts.items"
                  :search-input.sync="tenantContacts.search"
                  cache-items
                  return-object
                  chips
                  multiple
                  flat
                  hide-no-data
                  clearable
                  item-text="name"
                  item-value="id"
                  label="Tenant Contacts"
                  v-validate="''"
                  :error-messages="errors.collect('form.tenant_contacts')"
                  data-vv-name="form.tenant_contacts"
                  data-vv-as="Tenant Contacts"
                ></v-autocomplete>
              </v-col>
              <v-col cols="6">
                <v-autocomplete
                outlined
                small-chips
                  hide-details
                  class="pt-0"
                  v-model="form.tenant_agents"
                  :loading="tenantAgents.loading"
                  :items="tenantAgents.items"
                  :search-input.sync="tenantAgents.search"
                  cache-items
                  return-object
                  chips
                  multiple
                  flat
                  hide-no-data
                  clearable
                  item-text="name"
                  item-value="id"
                  label="Tenant Agents"
                  v-validate="''"
                  :error-messages="errors.collect('form.tenant_agents')"
                  data-vv-name="form.tenant_agents"
                  data-vv-as="Tenant Agents"
                >
                </v-autocomplete>
                      
              </v-col>
              <v-col cols="6">
                <v-autocomplete
                outlined
                small-chips
                  hide-details
                  class="pt-0"
                  v-model="form.tenant_agent_contacts"
                  :loading="tenantAgentContacts.loading"
                  :items="tenantAgentContacts.items"
                  :search-input.sync="tenantAgentContacts.search"
                  cache-items
                  return-object
                  chips
                  multiple
                  flat
                  hide-no-data
                  clearable
                  item-text="name"
                  item-value="id"
                  label="Tenant Agent Contacts"
                  v-validate="''"
                  :error-messages="
                    errors.collect('form.tenant_agent_contacts')
                  "
                  data-vv-name="form.tenant_agent_contacts"
                  data-vv-as="Tenant Agent Contacts"
                ></v-autocomplete>
              </v-col>
            </v-row>

            <v-divider class="my-8"></v-divider>

            <!-- <h2 class="text-h6 text-primary-600 mt-4">Rent</h2> -->
              <h5 class="text-h7 mb-1 pa-0 form-subheading">Rent</h5>

            <v-row>
              <v-col cols="6">
                <currency-input
                  v-model="form.rent_pa"
                  :validation="'decimal:2'"
                  label="Rent Pa"
                  :errorMsgs="errors.collect('form.rent_pa')"
                  :currency="form.currency ? form.currency.symbol : ''"
                ></currency-input>
              </v-col>
              <v-col cols="6">
                <currency-input
                  v-model="form.rent_sqft"
                  :validation="'decimal:2'"
                  label="Rent SQFT"
                  :errorMsgs="errors.collect('form.rent_sqft')"
                  :currency="form.currency ? form.currency.symbol : ''"
                ></currency-input>
              </v-col>
              <v-col cols="6">
                <currency-input
                  v-model="form.rateable_value"
                  :validation="'decimal:2'"
                  label="RV"
                  :errorMsgs="errors.collect('form.rateable_value')"
                  :currency="form.currency ? form.currency.symbol : ''"
                ></currency-input>
              </v-col>
              <v-col cols="6">
                <currency-input
                  v-model="form.service_charge"
                  :validation="'decimal:2'"
                  label="S/C"
                  :errorMsgs="errors.collect('form.service_charge')"
                  :currency="form.currency ? form.currency.symbol : ''"
                ></currency-input>
              </v-col>
              <v-col cols="12">
                <v-text-field
                outlined
                  dense
                  hide-details
                  v-model="form.incentive"
                  v-validate="''"
                  :error-messages="errors.collect('form.incentive')"
                  label="Incentive"
                  data-vv-name="form.incentive"
                  data-vv-as="Incentive"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-divider class="my-8"></v-divider>

            <!-- <h1 class="text-h6 text-primary-600 mt-4">Dates</h1> -->
            <h5 class="text-h7 mb-1 pa-0 form-subheading">Dates</h5>

            <v-row>
              <v-col cols="6">
                <v-text-field
                outlined
                  dense
                  hide-details
                  v-model="form.lease_start_date"
                  label="Lease Start Date"
                  hint="dd/mm/yyyy format"
                  v-validate="'date_format:dd/MM/yyyy'"
                  :error-messages="errors.collect('form.lease_start_date')"
                  data-vv-name="form.lease_start_date"
                  data-vv-as="Lease Start Date"
                  v-mask="'##/##/####'"
                  append-icon="mdi-calendar"
                  return-masked-value
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                outlined
                  dense
                  hide-details
                  v-model="form.lease_end_date"
                  label="Lease End Date"
                  hint="dd/mm/yyyy format"
                  v-validate="'date_format:dd/MM/yyyy'"
                  :error-messages="errors.collect('form.lease_end_date')"
                  data-vv-name="form.lease_end_date"
                  data-vv-as="Lease End Date"
                  v-mask="'##/##/####'"
                  append-icon="mdi-calendar"
                  return-masked-value
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                outlined
                  dense
                  hide-details
                  v-model="form.next_review_date"
                  label="Next Review Date"
                  hint="dd/mm/yyyy format"
                  v-validate="'date_format:dd/MM/yyyy'"
                  :error-messages="errors.collect('form.next_review_date')"
                  data-vv-name="form.next_review_date"
                  data-vv-as="Next Review Date"
                  v-mask="'##/##/####'"
                  append-icon="mdi-calendar"
                  return-masked-value
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-textarea
                
                  v-model="form.rent_review_clause"
                  label="Rent Review Clause"
                  data-vv-name="form.rent_review_clause"
                  data-vv-as="Rent Review Clause"
                  outlined
                ></v-textarea>
              </v-col>
              <v-col cols="6">
                <v-text-field
                outlined
                  dense
                  hide-details
                  v-model="form.break_date"
                  label="Next Break Date"
                  hint="dd/mm/yyyy format"
                  v-validate="'date_format:dd/MM/yyyy'"
                  :error-messages="errors.collect('form.break_date')"
                  data-vv-name="form.break_date"
                  data-vv-as="Next Break Date"
                  v-mask="'##/##/####'"
                  append-icon="mdi-calendar"
                  return-masked-value
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-textarea
                  v-model="form.break_clause"
                  label="Break Clause"  
                  data-vv-name="form.break_clause"
                  data-vv-as="Break Clause"
                  outlined
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <v-btn
                  @click="step = 6"
                  color="primary"
                  class="mb-4"
                  depressed
                >
                  Next Step
                </v-btn>
              </v-col>
            </v-row>
          </v-stepper-content>
          <v-stepper-step :step="(form.sale_type == 'investment' || form.sale_type == 'sale_and_lease_back') && typeToggle ? '6' : '5'" :complete="step > 6" :editable="step > 1" class="pt-4">
            Comments And Links <br/>
            <small v-if="step == 6 || step == 5">(Optional)</small>
          </v-stepper-step>
          <v-stepper-content :step="(form.sale_type == 'investment' || form.sale_type == 'sale_and_lease_back') && typeToggle ? '6' : '5'" :class="
          (form.sale_type == 'investment' || form.sale_type == 'sale_and_lease_back') && typeToggle  ?
          (step == 6 ? 'stepper-overflow-visible' : '') :
          (step == 5 ? 'stepper-overflow-visible' : '')
          ">
            <v-row class="mt-2" v-if="(typeToggle && selectedProperties) || (!typeToggle && selectedScheme)">
              <v-col cols="12">
                <v-text-field
                  v-model="linkInput"
                  label="Add Links"
                  hint="Add links to external documents or websites"
                  outlined
                  dense
                  hide-details
                  append-icon="mdi-plus"
                  class="mb-2"
                  @click:append="addLink"
                ></v-text-field>
                <v-simple-table dense style="width:100%; border: 1px solid #e0e0e0; border-radius: 4px;"  v-if="links.length > 0">
                    <template v-slot:default>
                        <tbody class="rpd-d-tbody">
                            <tr v-for="link in links" :key="index">
                                <td style="width:100%">
                                    <a :href="link" target="_blank">{{ link }}</a>
                                </td>
                                <td class="pr-2">
                                    <v-btn style="float:right" @click="removeLink(index)" small icon>
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
                <!-- <span >
                  <a
                    :href="link"
                    target="_blank"
                    color="primary"
                    class="mb-4"
                    depressed
                  >
                    {{ link }}
                </a>

                </span> -->
                <v-divider class="my-8"></v-divider>

                <comments hide-header="true" :entityId="typeToggle ? selectedProperties.value : selectedScheme.value" :entityType="typeToggle ? 'property' : 'scheme'" ref="comments" @contentStatus="checkContent"></comments>
              </v-col>

              <v-col cols="12">
                <v-btn
                  @click="submit"
                  color="primary"
                  class="mb-4"
                  depressed
                >
                  Finish
                </v-btn>
              </v-col>
              
            </v-row>

            
          </v-stepper-content>
        </v-stepper>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { mask } from "vue-the-mask";
import CurrencySelect from "@/components/common/currencySelect.vue";
import currencyInput from "@/components/common/currencyInput.vue";
import currencies from '@/data/currencies.json';
import Comments from '@/components/common/comments'
import { debounce } from "lodash";

export default {
  components: {
    CurrencySelect,
    currencyInput,
    Comments,
  },
  name: "SaleDealWizard",
  directives: {
    mask,
  },
  data() {
    return {
      dialog: false,

      step: 1,
      contactType: null,
      contactTypeText: null,
      tenantFilter: null,
      selectedScheme: null,
      schemes: [],
      schemeLoading: false,
      selectedProperties: null,
      properties: [],
      propertiesLoading: false,
      typeToggle: true,
      page: 1,
      Properties: [],

      prefill: false,
      commentStatus: false,

      areaChecklist: {
        nia_sqrt: false,
        itza_area: false,
        mezzanine: false,
        garden_centre: false,
        ground_floor_area: false,
        first_floor_area: false,
        second_floor_area: false,
        third_floor_area: false,
        basement_area: false,
        frontage_area: false,
      },

      saleTypes: [
        { value: 'vacant_possession', name: 'Vacant Possession' },
        { value: 'investment', name: 'Investment' },
        { value: 'sale_and_lease_back', name: 'Sale & Lease Back' },
        { value: 'owner_occupier', name: 'Owner Occupier' },
      ],

      linkInput:'',
      links:[],

      form: {
        planning: null,
        country: null,
        unit: null,
        street1: null,
        street2: null,
        town: null,
        postCode: null,
        region: null,

        scheme_name: null,
        scheme_type: null,
        opened: null,
        car_spaces: null,
        under_construction: null,

        landlords: [],
        landlord_contacts: [],
        landlord_agents: [],
        landlord_agent_contacts: [],

        prev_landlords: [],
        prev_landlord_contacts: [],
        prev_landlord_agents: [],
        prev_landlord_agent_contacts: [],

        area_size_type: null,
        nia_sqrt: null,
        itza_area: null,
        mezzanine: null,
        garden_centre: null,
        ground_floor_area: null,
        first_floor_area: null,
        second_floor_area: null,
        third_floor_area: null,
        basement_area: null,
        frontage_area: null,

        effective_date: null,
        sale_type: null,
        price_paid: null,

        tenant_id: null,
        legal_tenant_id: null,
        tenant_contacts: [],
        tenant_agents: [],
        tenant_agent_contacts: [],

        prev_tenant_id: null,
        prev_tenant_legal_id: null,

        currency: null,
        currencyCode: null,
        rent_pa: null,
        rent_sqft: null,
        rateable_value: null,
        service_charge: null,
        incentive: null,
        lease_start_date: null,
        lease_end_date: null,
        next_review_date: null,
        rent_review_clause: null,
        break_clause: null,
        break_date: null,
      },

      landlords: {
        loading: false,
        items: [],
        search: '',
      },
      landlordContacts: {
        loading: false,
        items: [],
        search: '',
      },
      landlordAgents: {
        loading: false,
        items: [],
        search: '',
      },
      landlordAgentContacts: {
        loading: false,
        items: [],
        search: '',
      },

      prevLandlords: {
        loading: false,
        items: [],
        search: '',
      },
      prevLandlordContacts: {
        loading: false,
        items: [],
        search: '',
      },
      prevLandlordAgents: {
        loading: false,
        items: [],
        search: '',
      },
      prevLandlordAgentContacts: {
        loading: false,
        items: [],
        search: '',
      },

      tenants: {
        loading: false,
        items: [],
        search: '',
      },
      legalTenants: {
        loading: false,
        items: [],
        search: '',
      },
      tenantContacts: {
        loading: false,
        items: [],
        search: '',
      },
      tenantAgents: {
        loading: false,
        items: [],
        search: '',
      },
      tenantAgentContacts: {
        loading: false,
        items: [],
        search: '',
      },


    };
  },
  methods: {
    checkContent(status){
        this.commentStatus = status
    },

    showDialog: function (prefill = null) {
      if(prefill){
        this.prefill = true;
        if(prefill.scheme_id){
          this.selectedScheme = {
            value: prefill.scheme_id,
            label: prefill.name
          }
          this.typeToggle = false;
          this.getSchemes();
          this.selectScheme();
        }else{
          this.selectedProperties = {
            value: prefill.property_id,
            label: prefill.name
          }
          this.typeToggle = true;
          this.getProperties();
          this.selectProperty();
        }
      }
      this.commentStatus = false;
      this.dialog = true;
    },

    closeDialog() {
      if(this.commentStatus){
        this.$notify.question('An unsaved comment exists, Do you still wish to close?', () => {
          this.selectedProperties = null;
          this.selectedScheme = null;
          this.step = 1;
          this.prefill = false;
          this.clearForm();
          this.dialog = false;
        })
      }else{
        this.selectedProperties = null;
        this.selectedScheme = null;
        this.step = 1;
        this.prefill = false;
        this.clearForm();
        this.dialog = false;
      }
      
    },

    selectContactType(type) {
      this.contactType = type;
      this.contactTypeText = type === 'tenant' ? 'Tenant' : 'Tenants Agent';
      this.step = 2;
    },

    searchProperties(prop){
        clearTimeout(this._timerId)
        this._timerId = setTimeout(() => {
          this.page = 1
          this.propertiesLoading = true
          this.Properties = []
          this.getProperties(prop)
        }, 500)
      },

    searchScheme(prop){
      clearTimeout(this._timerId)
      this._timerId = setTimeout(() => {
        this.page = 1
        this.schemeLoading = true
        this.schemes = []
        this.getSchemes(prop)
      }, 500)
    },

    getProperties(prop){
        // gets properties for dropdown
        this.$http.get("/properties/simple",{
          params: {
            q: prop,
            //filter by scheme if there is a selected scheme
            //scheme_id: this.selectedScheme.value ? this.selectedScheme.value : undefined,
            type: 'standalone',
            per_page: 50,
            include: 'address,tenant,scheme',
          }
        }).then(response => {
          // combine the address and tenant into a single string
          this.Properties = response.data.data.map(property => {
            let tenant = property.tenant.data.name ? property.tenant.data.name + ',' : 'Vacant,'
            let unit = property.building_num ? property.building_num : ''
            if(property.scheme_id){
              return {
                value: property.id,
                label: `${tenant} ${unit} ${property.scheme.data.name}, ${property.address.data.full_address}`
              }
            }else{
              return {
                value: property.id,
                label: `${tenant} ${unit} ${property.address.data.full_address}`
              }
            }
          })
          this.propertiesLoading = false
        }).catch(error => {
          this.propertiesLoading = false
        })
      },

    async getSchemes(prop){
    // gets schemes for dropdown
      this.$http.get("/schemes?include=address",{
        params: {
          q: prop,
          per_page: 50,
        }
      }).then(response => {
        if(prop != ''){
          // this.schemes = response.data.data.map(scheme => {
          //   return scheme.name
          // })
          this.schemes = response.data.data.map(scheme => {
            return {
              value: scheme.id,
              label: `${scheme.name} - ${scheme.address.data.full_address}`
            }
          })
        }else{
          this.schemes = []
        }
        
        this.schemeLoading = false
      }).catch(error => {
        this.schemeLoading = false
      })
    },

    async getTenants(search) {
      const response = await this.$http.get('/companies/', {
        params: {
          q: search,
          per_page: 100,
        }
      });
      this.tenants.items = response.data.data;
    },
    async getLegalTenants(search) {
      const response = await this.$http.get('/companies/', {
        params: {
          q: search,
          per_page: 100,
        }
      });
      this.legalTenants.items = response.data.data;
    },
    async getTenantAgents(search) {
      const response = await this.$http.get('/companies/', {
        params: {
          q: search,
          per_page: 100,
        }
      });
      this.tenantAgents.items = response.data.data;
    },
    async getTenantAgentContacts(search) {
      const response = await this.$http.get('/users/', {
        params: {
          q: search,
          per_page: 100,
          include: 'company',
        }
      });
      this.tenantAgentContacts.items = response.data.data;
    },
    async getTenantContacts(search) {
      const response = await this.$http.get('/users/', {
        params: {
          q: search,
          per_page: 100,
        }
      });
      this.tenantContacts.items = response.data.data;
    },

    async getCompanies(search, prev = false) {
      const response = await this.$http.get("/companies/", {
        params: {
          q: search,
          per_page: 100,
        },
      });
      if(prev){
        this.prevLandlords.items = response.data.data;
        this.prevLandlordAgents.items = response.data.data;
      }else{
        this.landlords.items = response.data.data;
        this.landlordAgents.items = response.data.data;
      }
    },
    async getUsers(search, prev = false) {
      const response = await this.$http.get("/users/", {
        params: {
          q: search,
          per_page: 100,
          include: "company",
        },
      });
      if(prev){
        this.prevLandlordContacts.items = response.data.data;
        this.prevLandlordAgentContacts.items = response.data.data;
      }else{
        this.landlordContacts.items = response.data.data;
        this.landlordAgentContacts.items = response.data.data;
      }
    },

    handleSelect(){
      if(this.typeToggle){
        this.selectProperty()
      }else{
        this.selectScheme()
      }
    },

    clearForm(){
      this.form = {
        planning: null,
        country: null,
        unit: null,
        street1: null,
        street2: null,
        town: null,
        postCode: null,

        scheme_name: null,
        scheme_type: null,
        opened: null,
        car_spaces: null,
        under_construction: null,
        // hidden scheme fields
        isSubscribed: null,
        region: null,

        landlords: [],
        landlord_contacts: [],
        landlord_agents: [],
        landlord_agent_contacts: [],

        prev_landlords: [],
        prev_landlord_contacts: [],
        prev_landlord_agents: [],
        prev_landlord_agent_contacts: [],

        area_size_type: null,
        nia_sqrt: null,
        itza_area: null,
        mezzanine: null,
        garden_centre: null,
        ground_floor_area: null,
        first_floor_area: null,
        second_floor_area: null,
        third_floor_area: null,
        basement_area: null,
        frontage_area: null,

        effective_date: null,
        sale_type: null,
        price_paid: null,

        tenant_id: null,
        legal_tenant_id: null,
        tenant_contacts: [],
        tenant_agents: [],
        tenant_agent_contacts: [],

        prev_tenant_id: null,
        prev_tenant_legal_id: null,

        currency: this.form.currency,
        rent_pa: null,
        rent_sqft: null,
        rateable_value: null,
        service_charge: null,
        incentive: null,
        lease_start_date: null,
        lease_end_date: null,
        next_review_date: null,
        rent_review_clause: null,
        break_clause: null,
        break_date: null,
      }
    },

    async selectProperty(){
      this.clearForm()
      await this.$http.get(`/properties/${this.selectedProperties.value}`,{
        params: {
          include: 'tenant,legal_tenant,address,files,scheme,unverified_history_columns,import_property,tenant_agents,tenant_agent_contacts,is_subscription_exists,tenant_contacts,landlords,landlord_agents,landlord_contacts,landlord_agent_contacts',
        }
      }).then(response => {
        this.form.planning = response.data.planning;
        this.form.country = response.data.address.country;
        this.form.unit = response.data.building_num;
        this.form.street1 = response.data.address.street;
        this.form.street2 = response.data.address.street2;
        this.form.town = response.data.address.city;
        this.form.postCode = response.data.address.post_code;

        this.form.reason = response.data.reason;

        this.form.prev_landlords = response.data.landlords.data;
        this.form.prev_landlord_contacts = response.data.landlord_contacts.data;
        this.form.prev_landlord_agents = response.data.landlord_agents.data;
        this.form.prev_landlord_agent_contacts = response.data.landlord_agent_contacts.data;
        this.prevLandlords.items = response.data.landlords.data;
        this.prevLandlordContacts.items = response.data.landlord_contacts.data;
        this.prevLandlordAgents.items = response.data.landlord_agents.data;
        this.prevLandlordAgentContacts.items = response.data.landlord_agent_contacts.data;

        this.form.prev_tenant_agents = response.data.tenant_agents.data;
        this.form.prev_tenant_agent_contacts = response.data.tenant_agent_contacts.data;
        // this.form.prev_tenant_id = response.data.tenant.data.id;
        this.form.prev_tenant_contacts = response.data.tenant_contacts.data;
        
        
        this.tenants.items = !Array.isArray(response.data.tenant) ? [response.data.tenant] : [];
        this.form.tenant_id = response.data.tenant.id;
        this.legalTenants.items = !Array.isArray(response.data.legal_tenant)? [response.data.legal_tenant] : [];
        this.form.legal_tenant_id = response.data.legal_tenant_id;
        this.form.tenant_agents = response.data.tenant_agents.data;
        this.form.tenant_agent_contacts = response.data.tenant_agent_contacts.data;
        this.form.tenant_contacts = response.data.tenant_contacts.data;
        this.tenantAgents.items = response.data.tenant_agents.data;
        this.tenantAgentContacts.items = response.data.tenant_agent_contacts.data;
        this.tenantContacts.items = response.data.tenant_contacts.data;

        this.form.nia_sqrt = response.data.nia_sqrt
        this.form.area_size_type = response.data.area_size_type
        this.form.itza_area = response.data.itza_area
        this.form.mezzanine = response.data.mezzanine
        this.form.garden_centre = response.data.garden_centre
        this.form.ground_floor_area = response.data.ground_floor_area
        this.form.first_floor_area = response.data.first_floor_area
        this.form.second_floor_area = response.data.second_floor_area
        this.form.third_floor_area = response.data.third_floor_area
        this.form.basement_area = response.data.basement_area
        this.form.frontage_area = response.data.frontage_area

        this.areaChecklist.nia_sqrt = this.form.nia_sqrt ? true : false;
        this.areaChecklist.itza_area = this.form.itza_area ? true : false;
        this.areaChecklist.mezzanine = this.form.mezzanine ? true : false;
        this.areaChecklist.garden_centre = this.form.garden_centre ? true : false;
        this.areaChecklist.ground_floor_area = this.form.ground_floor_area ? true : false;
        this.areaChecklist.first_floor_area = this.form.first_floor_area ? true : false;
        this.areaChecklist.second_floor_area = this.form.second_floor_area ? true : false;
        this.areaChecklist.third_floor_area = this.form.third_floor_area ? true : false;
        this.areaChecklist.basement_area = this.form.basement_area ? true : false;
        this.areaChecklist.frontage_area = this.form.frontage_area ? true : false;

        if(response.data.currency){
          this.form.currency = this.$refs.currencySelectRef.selectByCode(response.data.currency)
        }else{
          this.form.currency = this.$refs.currencySelectRef.selectByCode(this.$auth.user().currency ? this.$auth.user().currency : 'GBP')
        }
        this.form.rent_pa = response.data.rent_pa;
        this.form.rent_sqft = response.data.rent_sqft;
        this.form.rateable_value = response.data.rateable_value;
        this.form.service_charge = response.data.service_charge;
        this.form.incentive = response.data.incentive;
        
        this.form.lease_start_date = response.data.lease_start_date;
        this.form.lease_end_date = response.data.lease_end_date;
        this.form.next_review_date = response.data.next_review_date;
        this.form.rent_review_clause = response.data.rent_review_clause;
        this.form.break_clause = response.data.break_clause;
        this.form.break_date = response.data.break_date;

        this.step = 2;
      })
    },

    async selectScheme(){
      this.clearForm()
      await this.$http.get(`/schemes/${this.selectedScheme.value}`,{
        params: {
          include: 'address,files,properties,landlords,landlord_agents,tenant,tenant_agents,tenant_agent_contacts,tenant_contacts,landlord_contacts,landlord_agent_contacts',
        }
      }).then(response => {
        this.form.prev_landlords = response.data.landlords.data;
        this.form.prev_landlord_contacts = response.data.landlord_contacts.data;
        this.form.prev_landlord_agents = response.data.landlord_agents.data;
        this.form.prev_landlord_agent_contacts = response.data.landlord_agent_contacts.data;
        this.prevLandlords.items = response.data.landlords.data;
        this.prevLandlordContacts.items = response.data.landlord_contacts.data;
        this.prevLandlordAgents.items = response.data.landlord_agents.data;
        this.prevLandlordAgentContacts.items = response.data.landlord_agent_contacts.data;

        this.form.country = response.data.address.country;
        this.form.unit = response.data.building_num;
        this.form.street1 = response.data.address.street;
        this.form.street2 = response.data.address.street2;
        this.form.town = response.data.address.city;
        this.form.postCode = response.data.address.post_code;
        this.form.region = response.data.address.region;

        this.form.scheme_name = response.data.name;
        this.form.scheme_type = response.data.type;
        this.form.opened = response.data.opened_at;
        this.form.car_spaces = response.data.car_spaces;
        this.form.under_construction = response.data.is_under_construction;

        this.form.reason = response.data.reason;

        this.step = 2;
      })
    },

    prepForm() {
      // if prev exists but not current, set current to prev
      // if (this.form.prev_landlords.length && !this.form.landlords.length) {
      //   this.form.landlords = this.form.prev_landlords;
      // }
      // if (this.form.prev_landlord_contacts.length && !this.form.landlord_contacts.length) {
      //   this.form.landlord_contacts = this.form.prev_landlord_contacts;
      // }
      // if (this.form.prev_landlord_agents.length && !this.form.landlord_agents.length) {
      //   this.form.landlord_agents = this.form.prev_landlord_agents;
      // }
      // if (this.form.prev_landlord_agent_contacts.length && !this.form.landlord_agent_contacts.length) {
      //   this.form.landlord_agent_contacts = this.form.prev_landlord_agent_contacts;
      // }

      // if form sale type is not investment or sale and lease back, remove tenant details
      if ((this.form.sale_type !== 'investment' && this.form.sale_type !== 'sale_and_lease_back') && this.typeToggle) {
        this.form.tenant_id = null;
        this.form.legal_tenant_id = null;
        this.form.tenant_contacts = [];
        this.form.tenant_agents = [];
        this.form.tenant_agent_contacts = [];
        this.form.rent_pa = null;
        this.form.rent_sqft = null;
        this.form.rateable_value = null;
        this.form.service_charge = null;
        this.form.incentive = null;
        this.form.currency = null;
        this.form.lease_start_date = null;
        this.form.lease_end_date = null;
        this.form.rent_review_clause = null;
        this.form.next_review_date = null;
        this.form.break_clause = null;
        this.form.break_date = null;

      }
      if (this.typeToggle){
        // clear unused fields
        this.form.scheme_name = null;
        this.form.scheme_type = null;
        this.form.opened = null;
        this.form.car_spaces = null;
        this.form.under_construction = null;
      }else{
        // clear unused fields
        this.planning = null;
        
      }
    },

    submit(){
      if(this.commentStatus){
        this.$notify.question('An unsaved comment exists, Do you wish to finish the wizard?', () => {
          this.commentStatus = false
          this.submitForm()
        })
      }else{
        this.submitForm()
      }
    },
      
    submitForm() {
      this.prepForm();
      this.$http.post("/deals", {
        deal_type: 'sale',
        scheme_id: this.selectedScheme ? this.selectedScheme.value : undefined,
        property_id: this.selectedProperties ? this.selectedProperties.value : undefined,

        effective_date: this.form.effective_date ? this.formatDate(this.form.effective_date) : undefined,
        sale_type: this.form.sale_type ? this.form.sale_type : undefined,
        sale_price: this.form.price_paid ? this.form.price_paid : undefined,
        reason: this.form.reason ? this.form.reason : undefined,
        tenant_id: this.form.tenant_id ? this.form.tenant_id : undefined,
        legal_tenant_id: this.form.legal_tenant_id ? this.form.legal_tenant_id : undefined,

        landlords: this.form.landlords.length > 0 ? this.form.landlords.map(landlord => landlord.id) : undefined,
        landlord_contacts: this.form.landlord_contacts.length > 0 ? this.form.landlord_contacts.map(landlord_contact => landlord_contact.id) : undefined,
        landlord_agents: this.form.landlord_agents.length > 0 ? this.form.landlord_agents.map(landlord_agent => landlord_agent.id) : undefined,
        landlord_agent_contacts: this.form.landlord_agent_contacts.length > 0 ? this.form.landlord_agent_contacts.map(landlord_agent_contact => landlord_agent_contact.id) : undefined,
        prev_landlords: this.form.prev_landlords.length > 0 ? this.form.prev_landlords.map(prev_landlord => prev_landlord.id) : undefined,
        prev_landlord_contacts: this.form.prev_landlord_contacts.length > 0 ? this.form.prev_landlord_contacts.map(prev_landlord_contact => prev_landlord_contact.id) : undefined,
        prev_landlord_agents: this.form.prev_landlord_agents.length > 0 ? this.form.prev_landlord_agents.map(prev_landlord_agent => prev_landlord_agent.id) : undefined,
        prev_landlord_agent_contacts: this.form.prev_landlord_agent_contacts.length > 0 ? this.form.prev_landlord_agent_contacts.map(prev_landlord_agent_contact => prev_landlord_agent_contact.id) : undefined,

        tenant_agents: this.form.tenant_agents.length > 0 ? this.form.tenant_agents.map(tenant_agent => tenant_agent.id) : undefined,
        tenant_agent_contacts: this.form.tenant_agent_contacts.length > 0 ? this.form.tenant_agent_contacts.map(tenant_agent_contact => tenant_agent_contact.id) : undefined,
        tenant_contacts: this.form.tenant_contacts.length > 0 ? this.form.tenant_contacts.map(tenant_contact => tenant_contact.id) : undefined,
        
        lease_start_date: this.form.lease_start_date ? this.formatDate(this.form.lease_start_date) : undefined,
        lease_end_date: this.form.lease_end_date ? this.formatDate(this.form.lease_end_date) : undefined,
        rent_review_clause: this.form.rent_review_clause ? this.form.rent_review_clause : undefined,
        next_review_date: this.form.next_review_date ? this.formatDate(this.form.next_review_date) : undefined,
        break_clause: this.form.break_clause ? this.form.break_clause : undefined,
        break_date: this.form.break_date ? this.formatDate(this.form.break_date) : undefined,

        rent_pa: this.form.rent_pa ? this.form.rent_pa : undefined,
        rent_sqft: this.form.rent_sqft ? this.form.rent_sqft : undefined,
        rateable_value: this.form.rateable_value ? this.form.rateable_value : undefined,
        service_charge: this.form.service_charge ? this.form.service_charge : undefined,
        incentive: this.form.incentive ? this.form.incentive : undefined,
        currency: this.form.currency ? this.form.currency.code : undefined,
        planning: this.form.planning ? this.form.planning : undefined,

        links: this.links.length > 0 ? this.links : undefined,
      }).then(response => {
        this.submitAddresses();

      });
    },

    async submitScheme() {
      
      await this.$http.put(`/schemes/${this.selectedScheme.value}`, {
          address: {
            country: this.form.country,
            unit: this.form.unit,
            street: this.form.street1,
            street2: this.form.street2,
            city: this.form.town,
            post_code: this.form.postCode,
            region: this.form.region,
          },
          name: this.form.scheme_name,
          type: this.form.scheme_type,
          opened: this.form.opened,
          car_spaces: this.form.car_spaces,
          is_under_construction: this.form.under_construction,
          landlords: this.form.landlords.length > 0 ? this.form.landlords.map(landlord => landlord.id) : [],
          landlord_contacts: this.form.landlord_contacts.length > 0 ? this.form.landlord_contacts.map(landlord_contact => landlord_contact.id) : [],
          landlord_agents: this.form.landlord_agents.length > 0 ? this.form.landlord_agents.map(landlord_agent => landlord_agent.id) : [],
          landlord_agent_contacts: this.form.landlord_agent_contacts.length > 0 ? this.form.landlord_agent_contacts.map(landlord_agent_contact => landlord_agent_contact.id) : [],
      }).then(response => {
        this.closeDialog();
        this.$emit('update');
      });
    },

    async submitAddresses() {
      const {data} = await this.$http.get(`/properties/${this.typeToggle ? this.selectedProperties.value : this.selectedScheme.value}`, {include: 'address',})
      this.$http.put(`addresses/${data.address_id}`, {
        country: this.form.country,
        unit: this.form.unit,
        street: this.form.street1,
        street2: this.form.street2,
        city: this.form.town,
        post_code: this.form.postCode,
      }).then(response => {
        // this.$router.resolve({name: ""})
        if (this.typeToggle){
          this.submitAreas();
        }else{
          this.submitScheme();
        }
       
      });
    },

    formatCurrency(value) {
      if (!value) return null;
      // value = value.replace(/,/g, '');
      value = parseFloat(value);
      value = value.toFixed(2)
      // value = value.replace(/\d(?=(\d{3})+\.)/g, '$&,');
      return value;
    },

    async submitAreas() {
      if(!this.selectedProperties) return;
      await this.$http.put(`/properties/${this.selectedProperties.value}/areas`, {
        area_size_type: this.form.area_size_type,
        nia_sqrt: this.areaChecklist.nia_sqrt ? this.form.nia_sqrt : undefined,
        itza_area: this.areaChecklist.itza_area ? this.form.itza_area : undefined,
        mezzanine: this.areaChecklist.mezzanine ? this.form.mezzanine : undefined,
        garden_centre: this.areaChecklist.garden_centre ? this.form.garden_centre : undefined,
        ground_floor_area: this.areaChecklist.ground_floor_area ? this.form.ground_floor_area : undefined,
        first_floor_area: this.areaChecklist.first_floor_area ? this.form.first_floor_area : undefined,
        second_floor_area: this.areaChecklist.second_floor_area ? this.form.second_floor_area : undefined,
        third_floor_area: this.areaChecklist.third_floor_area ? this.form.third_floor_area : undefined,
        basement_area: this.areaChecklist.basement_area ? this.form.basement_area : undefined,
        frontage_area: this.areaChecklist.frontage_area ? this.form.frontage_area : undefined,
      }).then(response => {
        this.closeDialog();
        this.$emit('update');
      });
    },
    

    formatDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },

    handlePrefill(){
      // check for route params, if property_id is present, select the property and set prefilled to true
      const query = this.$route.query;
      if(query.property_id){
        this.selectedProperties = {
          value: query.property_id,
          label: query.name
        }
        this.prefill = true;
        this.getProperties();
        this.selectProperty();
      }
    },


    addLink(){
      if(!this.links){
        this.links = []
      }
      if(this.linkInput){

        // verify link regex
        let expression = '(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})'
        let regex = new RegExp(expression)
        if(!regex.test(this.linkInput)){
          this.$notify.error('Invalid URL')
          return
        }
        this.links.push(this.linkInput)
        this.linkInput = ''
      }
    },

    removeLink(index){
      this.links.splice(index, 1)
    },

    debounce(fn, delay) {
      
      clearTimeout(this._timerId)
      this._timerId = setTimeout(() => {
        fn();
      }, delay);
    }
  },

  mounted() {
    this.handlePrefill();
  },
  
  watch: {

    'tenants.search'(search) {
      if (!search) return;
      this.debounce(() => {
        this.getTenants(search);
      }, 375);
    },
    'legalTenants.search'(search) {
      if (!search) return;
      this.debounce(() => {
        this.getLegalTenants(search);
      }, 375);
    },
    'tenantAgents.search'(search) {
      if (!search) return;
      this.debounce(() => {
        this.getTenantAgents(search);
      }, 375);
    },
    'tenantAgentContacts.search'(search) {
      if (!search) return;
      this.debounce(() => {
        this.getTenantAgentContacts(search);
      }, 375);
    },
    'tenantContacts.search'(search) {
      if (!search) return;
      this.debounce(() => {
        this.getTenantContacts(search);
      }, 375);
    },
    'landlords.search'(search) {
      if (!search) return;
      this.debounce(() => {
        this.getLandlords(search);
      }, 375);
    },
    'landlordContacts.search'(search) {
      if (!search) return;
      this.debounce(() => {
        this.getLandlordContacts(search);
      }, 375);
    },
    'landlordAgents.search'(search) {
      if (!search) return;
      this.debounce(() => {
        this.getLandlordAgents(search);
      }, 375);
    },
    'landlordAgentContacts.search'(search) {
      if (!search) return;
      this.debounce(() => {
        this.getLandlordAgentContacts(search);
      }, 375);
    },
    "landlords.search"(search) {
      if (!search) return;
      this.debounce(() => {
        this.getCompanies(search);
      }, 375);
    },
    "landlordContacts.search"(search) {
      if (!search) return;
      this.debounce(() => {
        this.getUsers(search);
      }, 375);
    },
    "landlordAgents.search"(search) {
      if (!search) return;
      this.debounce(() => {
        this.getCompanies(search);
      }, 375);
    },
    "landlordAgentContacts.search"(search) {
      if (!search) return;
      this.debounce(() => {
        this.getUsers(search);
      }, 375);
    },
    "prevLandlords.search"(search) {
      if (!search) return;
      this.debounce(() => {
        this.getCompanies(search, true);
      }, 375);
    },
    "prevLandlordContacts.search"(search) {
      if (!search) return;
      this.debounce(() => {
        this.getUsers(search, true);
      }, 375);
    },
    "prevLandlordAgents.search"(search) {
      if (!search) return;
      this.debounce(() => {
        this.getCompanies(search, true);
      }, 375);
    },
    "prevLandlordAgentContacts.search"(search) {
      if (!search) return;
      this.debounce(() => {
        this.getUsers(search, true);
      }, 375);
    },

    "form.landlord_agent_contacts"(val) {
      if (val.length) {
        val.forEach(contact => {
          if (contact.company && !this.form.landlord_agents.find(company => company.id === contact.company_id)) {
              this.form.landlord_agents.push(contact.company.data);
              if(!this.landlordAgents.items.find(company => company.id === contact.company_id)){
                this.landlordAgents.items.push(contact.company.data);
              }
          }
        });
      }
    },

    "form.landlord_contacts"(val) {
      
      if (val.length) {
        val.forEach(contact => {
          if (contact.company && !this.form.landlords.find(company => company.id === contact.company_id)) {
            this.form.landlords.push(contact.company.data);
            if(!this.landlords.items.find(company => company.id === contact.company_id)){
              this.landlords.items.push(contact.company.data);
            }
          }
        });
      }
    },

    "form.tenant_agent_contacts"(val) {
      if (val.length) {
        val.forEach(contact => {
          if (contact.company && !this.form.tenant_agents.find(company => company.id === contact.company_id)) {
            this.form.tenant_agents.push(contact.company.data);
            if(!this.tenantAgents.items.find(company => company.id === contact.company_id)){
              this.tenantAgents.items.push(contact.company.data);
            }
          }
        });
      }
    },

    "form.tenant_contacts"(val) {
      if (val.length) {
        val.forEach(contact => {
          if (contact.company && !this.form.tenants.find(company => company.id === contact.company_id)) {
            this.form.tenants.push(contact.company.data);
            if(!this.tenants.items.find(company => company.id === contact.company_id)){
              this.tenants.items.push(contact.company.data);
            }
          }
        });
      }
    },

    "form.prev_tenant_agent_contacts"(val) {
      if (val.length) {
        val.forEach(contact => {
          if (contact.company && !this.form.prev_tenant_agents.find(company => company.id === contact.company_id)) {
            this.form.prev_tenant_agents.push(contact.company.data);
            if(!this.prevTenantAgents.items.find(company => company.id === contact.company_id)){
              this.prevTenantAgents.items.push(contact.company.data);
            }
          }
        });
      }
    },

    "step"(step) {
      if ((step === "5" || step == 5) && (this.form.sale_type == 'investment' || this.form.sale_type == 'sale_and_lease_back')) {
        if(this.form.currencyCode){
          this.form.currency = this.$refs.currencySelectRef.selectByCode(this.form.currencyCode)
        }else{
          this.form.currency = this.$refs.currencySelectRef.selectByCode(this.$auth.user().currency ? this.$auth.user().currency : 'GBP')
        }
      }
    },
  },

  computed: {
    // verify that selectedProperties.value or selectedScheme.value exists, avoid returning errors when the user has not selected a property or scheme
    propertyValidation() {
      return this.selectedProperties && this.selectedProperties.value || this.selectedScheme && this.selectedScheme.value ? false : true;
    },

    schemeValidation() {
      return this.selectedScheme && this.selectedScheme.value || this.selectedProperties && this.selectedProperties.value ? false : true;
    },

  },
}
</script>
<style>
  
</style>